//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DetailKonfiguraceDrms.ts					</Name>
//    <Description> Dialog detailu licence										</Description>
//    <Author>      thazmuka													</Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2019							</Copyright>
//    <Created>     2018-02-21													</Created>
//  </FileHeader>

namespace Gordic.Adm.WebControls {

    const { gcontent } = Decorators;

    /** inteface - Response služeb pro Detail Stupen Schvaleni Epk */
    export interface IDetailKonfiguraceDrmsResponse {
        /** data výstupu */
        data: Gordic.AdmIsl.Interface.GKonfiguraceDrmsDto,
        result: {
            /** data výstupu */
            data: Gordic.AdmIsl.Interface.GKonfiguraceDrmsDto,
            /** chyby */
            errors: {
                /** zpráva chyby */
                message: string
            }[],
            /** typ výstupu operace */
            kind: Adm.Utils.GOperationResultKind
        }
    }

    //#endregion

    /** Dialog detailu  */
    @gcontent
    export class DetailKonfiguraceDrms extends GContentBase<DetailBase> {

        //#region attributes

        ///** příznak, že se jedná o nový záznam */
        //private newRecord: boolean;
        ///** Příznak, že okno se nachází v editačním režimu */
        //private editMode: boolean;
        /** PK - jeden */
        private jeden: number | null;
        /** data detailu */
        private data: Gordic.AdmIsl.Interface.GKonfiguraceDrmsDto;
        ///*** element panelu v sidebaru */
        //private panelElement: JQuery<HTMLElement>
        //private panelId: string;
        ///** elmenet sidebaru */
        //private sidebar: JQuery<HTMLElement>;
        /** příznak přímého přístupu na detail */
        private detailCommand: boolean



        /** onContentReady */
        public onContentReady() {
            this.init();
        }


        /** init content */
        private init() {

            if (this.editMode === undefined)
                this.editMode = false;

            if (this.newRecord === undefined)
                this.newRecord = false;

            // lezu na detail ze seznamu a ne pomocí linku
            if (this.detailCommand === false) {
                var GinListControlsObject = (Gin.DetailBuilderComponents as any).GinListControls.create(this);
                this.actions.addRange(GinListControlsObject.actions);
                this.createStatusBar(GinListControlsObject.menubar);
                $.extend(this, GinListControlsObject.contentExtensions);
            }

            this.setTitle();
            this.createMenuBar();
            this.createForm();
            this.createCommandBar();

            // lezu na detail ze seznamu a ne pomocí linku
            if (this.detailCommand === false) {
                // vytvořit šipky na procházení detailu
                (this as any).listControls_setup({
                    //gridRemoteControl: this.gridRemoteControl,
                    //funkce, která řádek z gridu přetransformuje v dto pro zavolání this.load(dto); Může vracet promise.
                    rowToDto: function (gridState) {
                        return {
                            jeden: gridState.currentRow.data.jeden
                        };
                    },
                    //template pro tooltip na šipce následující
                    nextItemTemplate: "jres:33000155: {jeden}",
                    //template pro tooltip na šipce předchozí
                    prevItemTemplate: "jres:33000156: {jeden}"
                });
                (this as any).listControls_updateCaptions();
            }
        }

        public closing() {

            var dfd = $.Deferred();

            // jedná se o editační mód, nelze odejít z detailu
            if ((this.editMode === true) && this.newRecord === false) {
                alert("jres:32000126"); //RC 32000126 : Na okně jsou rozeditovaná data, uložte je nebo zrušte.
                return dfd.reject();
            }
            else {
                return dfd.resolve();
            }
        }

        //#region ready & init

        /** refreshDetail content */
        private refreshDetail(): void {

            this.HideAllFlash();
            this.load();
        }

        /** Načtení dat ze serveru na následné nastavení na detail okně */
        private loadData() {

            this.HideAllFlash();


            this.isl.KonfiguraceDrms.checkIsAdministrate().get().done((result) => {
                var fragments: string[] = [Utils.GAdmIslConst.detail];
                if (result == false)
                    this.newRecord = true;

                if (this.newRecord == true)
                   fragments.push(Utils.GAdmIslConst.defaultValuesForNewRecord);

                var readResult: any = this.isl.KonfiguraceDrms.read({
                    data: { jeden: 0 },
                    fragments: fragments
                }).get();


                // SUCCESS
                readResult.done((output: IDetailKonfiguraceDrmsResponse) => {
                    if (output.result.kind === Utils.GOperationResultKind.Success) {
                        this.data = output.data;
                        // nema PK sloupce

                        this.element.findFields().gfield("model", "apply", this.data);

                        var sslden_spz_field = $(".sslden_spz").parent().parent();
                        if (this.data.s_vicden_spz === 1) {
                            sslden_spz_field.hide();
                        }
                        else {
                            sslden_spz_field.show();
                        }

                        var rok_spz_field = $(".rok_spz").parent().parent();
                        if (this.data.rok_spz_current === 1) {
                            rok_spz_field.hide();
                        }
                        else {
                            rok_spz_field.show();
                        }

                        var rok_cj_field = $(".rok_cj").parent().parent();
                        if (this.data.rok_cj_current === 1) {
                            rok_cj_field.hide();
                        }
                        else {
                            rok_cj_field.show();
                        }

                        var sslden_cj_field = $(".sslden_cj").parent().parent();
                        if (this.data.s_vicden_cj === 1) {
                            sslden_cj_field.hide();
                        }
                        else {
                            sslden_cj_field.show();
                        }


                        var spis_graf_v_field = $(".spis_graf_v").parent().parent();
                        if (this.data.s_vicgraf === 0) {
                            spis_graf_v_field.hide();
                        }
                        else {
                            spis_graf_v_field.show();
                        }

                        if (this.newRecord)
                            this.setEditMode(true);       // při NEW je okno ihned přepnuto do edit režimu - musí být před setMenuButtons()
                        this.setMenuButtons(this.editMode);
                        this.createSidebar();
                        //this.createGTab();
                    } else {
                        var errors = output.result.errors;
                        for (var index = 0; index < errors.length; index++) {
                            var error = errors[index];
                            this.ShowLoadError(error.message, index);
                        }
                    }
                });
                // ERROR
                readResult.fail((err) => {
                    this.ShowLoadError("jres:32131045!");
                });

            })
        } // loadData

        //#endregion

        /** Uložení dat formuláře do databáze */
        private saveData(nova_data: Gordic.AdmIsl.Interface.GKonfiguraceDrmsDto): void {

            this.HideAllFlash();

            if (this.newRecord === true)
                this.jeden = null;

            var upsertResult: any = this.isl.KonfiguraceDrms.upsert({ data: nova_data }).get();

            upsertResult.done((output: IDetailKonfiguraceDrmsResponse) => {

                if (output.result.kind === Utils.GOperationResultKind.Success) {
                    DetailBase.ClearAllCache(this);
                    this.data = output.data; // prevezmu nova data vznikla ulozenim
                    // nema PK sloupce

                    this.element.findFields().gfield("model", "apply", this.data);  // nasetování nových dat do detailu
                    this.ShowSaveSuccess();
                    this.createSidebar();

                    //#region ** Ukončení editačního módu po uložení **
                    this.newRecord = false;
                    this.setEditMode(false);
                    this.setMenuButtons(false);
                    //#endregion

                }
                else {
                    var errors = output.result.errors;
                    for (var index = 0; index < errors.length; index++) {
                        var error = errors[index];
                        this.ShowSaveError(error.message, index);
                    }
                }

            });

            upsertResult.fail((err) => {
                console.error("Chyba uložení! ");
                this.ShowSaveError("jres:32000125!");   //RC 32000125 : Chyba uložení
            });
        }


        /** vytvořit statusbar */
        private createStatusBar(GinListControlsObject?: any) {
            const bar: MenuParams[] = [];
            if (GinListControlsObject !== undefined) {
                bar.push.apply(bar, GinListControlsObject);
            }
            this.statusBar(bar);
        }

        //#endregion

        //#region data

        /** Skrytí všech flash */
        private HideAllFlash() {
            // skryji případné Flash panely - musím začít s čistým štítem
            this.hideFlash("idSaveSuccess");
            this.hideFlash("idSaveError");
            this.hideFlash("idLoadError");
            for (var index = 0; index < 10; index++) {
                this.hideFlash("idSaveError" + index);
                this.hideFlash("idLoadError" + index);
            }
        }
        /** Zobrazí příznaku úspěšného uložení */
        private ShowSaveSuccess() {
            this.showFlash("jres:32000123", "g-state-success", 2000, "idSaveSuccess"); //RC 32000123 : Detail byl úspěšně uložen
        }
        /** Zobrazí příznaku chyby při uložení dat */
        private ShowSaveError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError"); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idSaveError" + index); //RC 32000124 : Chyba
        }
        /** Zobrazí příznaku chyby při načtení dat */
        private ShowLoadError(text: string, index?: number) {
            if (index === undefined)
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError"); //RC 32000124 : Chyba
            else
                this.showFlash("jres:32000124: " + text, "g-state-error", 0, "idLoadError" + index); //RC 32000124 : Chyba
        }



        //#region title

        /** nastavit titulek dialogu */
        private setTitle() {

            var title = "";

            if (this.newRecord === false) {
                title = "jres:32131119 "   //RC 32131119 : Globální nastavení konfigurace DRMS
            }
            else {
                title = "jres:32000121" //RC 32000121 : Nový záznam
            }

            this.title = title;

        }


        //#endregion

        //#region form

        /** vytvořit formulář a načtení dat ze serveru */
        private createForm() {

            var form = $("<div>").appendTo(this.element);

            var Form = new Gordic.Forms.Form({							// odstranit any, az bude .d.ts k filefield policku
                name: "FormKonfiguraceDrmsService",
                layoutDescriptor: "L1M1S1, L-4-8-0, M-4-8-0, S-12-12-0",
            });

            Form
                .addSection("jres:32131119") //RC 32131119 : Globální nastavení konfigurace DRMS

            Form
                //.addRow({
                //    label: "jres:32131027" 
                //})
                //.addField("gstringbox", {
                //    name: "jeden",
                //    customClass: "w-6",
                //    disabled: !this.newRecord
                //})


                // s_vicden_spz
                .addSection("jres:32131134") //RC 32131134 : Deník pro spisy
                .addRow()
                .addField("gradio", {
                    name: "s_vicden_spz",
                    disabled: !this.newRecord,
                    radios: [
                        { value: "1", label: 'jres:32131132' }, //RC 32131132 : Více deníků
                        { value: "0", label: 'jres:32131133' } //RC 32131133 : Jeden deník
                    ],
                    change: (ev, obj) => {
                        var sslden_spz_field = $(".sslden_spz").parent().parent();
                        if (obj.value === "1") {
                            sslden_spz_field.hide();
                        }
                        else {
                            sslden_spz_field.show();
                        }
                    }
                })
                // sslden_spz
                .addRow({
                    label: "jres:32131137" //RC 32131137 : Aktuální deník
                })
                .addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                    dropdown: false,                                                                 // políčko jako combobox
                    name: "sslden_spz",                                                            // název položky
                    model: "model.sslden_spz=value.sslden",                                       // model je to, co je na teto strance , value je to, co je v políčku
                    disabled: true,
                    customClass: "sslden_spz",                                 // pojmenovana class pro hledani v ramci funkce pro zneviditelneni policka
                    serverFilters: {
                        priz_den_cj: [0, 3],
                        aktivita: 100,
                        PouzeUzivatelskeDeniky: false
                    },                    
                })
                .addRow({
                    label: "jres:32131144" //RC 32131144 : Rok
                })
                .addField("gradio", {
                    name: "rok_spz_current",
                    disabled: !this.newRecord,
                    radios: [
                        { value: "1", label: 'jres:32131142' }, //RC 32131142 : Dle datumu
                        { value: "0", label: 'jres:32131143' } //RC 32131143 : Zadaný
                    ],
                    change: (ev, obj) => {
                        var rok_spz_field = $(".rok_spz").parent().parent();
                        if (obj.value === "1") {
                            rok_spz_field.hide();
                        }
                        else {
                            rok_spz_field.show();
                        }
                    }
                })
                // rok_spz
                .addRow({
                    label: "jres:32131135" //RC 32131135 : Aktuální rok
                })
                .addField("gnumberbox", {
                    name: "rok_spz",
                    customClass: "rok_spz",                                 // pojmenovana class pro hledani v ramci funkce pro zneviditelneni policka
                    disabled: !this.newRecord
                })



                // s_vicden_spz
                .addSection("jres:32131136") //RC 32131136 : Deník pro dokumenty
                .addRow()
                .addField("gradio", {
                    name: "s_vicden_cj",
                    disabled: !this.newRecord,
                    radios: [
                        { value: "1", label: 'jres:32131132' }, //RC 32131132 : Více deníků
                        { value: "0", label: 'jres:32131133' } //RC 32131133 : Jeden deník
                    ],
                    change: (ev, obj) => {
                        var sslden_cj_field = $(".sslden_cj").parent().parent();
                        if (obj.value === "1") {
                            sslden_cj_field.hide();
                        }
                        else {
                            sslden_cj_field.show();
                        }
                    }
                })
                // sslden_cj
                .addRow({
                    label: "jres:32131137" //RC 32131137 : Aktuální deník
                })
                .addField("gselectbox", Gordic.Prefabs.Select.sslsden(), {
                    dropdown: false,                                                                 // políčko jako combobox
                    name: "sslden_cj",                                                            // název položky
                    model: "model.sslden_cj=value.sslden",                                       // model je to, co je na teto strance , value je to, co je v políčku
                    disabled: true,
                    customClass: "sslden_cj",                                 // pojmenovana class pro hledani v ramci funkce pro zneviditelneni policka
                    serverFilters: {
                        priz_den_cj: [1, 2],
                        aktivita: 100,
                        PouzeUzivatelskeDeniky: false
                    },                    
                })

                .addRow({
                    label: "jres:32131144" //RC 32131144 : Rok
                })
                .addField("gradio", {
                    name: "rok_cj_current",
                    disabled: !this.newRecord,
                    radios: [
                        { value: "1", label: 'jres:32131142' }, //RC 32131142 : Dle datumu
                        { value: "0", label: 'jres:32131143' } //RC 32131143 : Zadaný
                    ],
                    change: (ev, obj) => {
                        var rok_cj_field = $(".rok_cj").parent().parent();
                        if (obj.value === "1") {
                            rok_cj_field.hide();
                        }
                        else {
                            rok_cj_field.show();
                        }
                    }
                })
                // rok_spz
                .addRow({
                    label: "jres:32131135" //RC 32131135 : Aktuální rok
                })
                .addField("gnumberbox", {
                    name: "rok_cj",
                    customClass: "rok_cj",                                 // pojmenovana class pro hledani v ramci funkce pro zneviditelneni policka
                    disabled: !this.newRecord
                })


                // s_vicgraf
                .addSection("jres:32131138") //RC 32131138 : Distribuční grafy
                .addRow()
                .addField("gradio", {
                    name: "s_vicgraf",
                    disabled: !this.newRecord,
                    radios: [
                        { value: "1", label: 'jres:32131126' }, //RC 32131126 : Dva grafy
                        { value: "0", label: 'jres:32131127' } //RC 32131127 : Jeden graf
                    ],
                    change: (ev, obj) => {

                        var spis_graf_v_field = $(".spis_graf_v").parent().parent();

                        if (obj.value === "0") {
                            spis_graf_v_field.hide();
                        }
                        else {
                            spis_graf_v_field.show();
                        }

                    }
                })
                // spis_graf
                .addRow({
                    label: "jres:32131124" //RC 32131124 : Podací graf
                })
                .addField("gselectbox", Gordic.Prefabs.Select.wflsgra(), {
                    dropdown: false,                                                                 // políčko jako combobox
                    name: "spis_graf",                                                            // název položky
                    model: "model.spis_graf=value.spis_graf",                                       // model je to, co je na teto strance , value je to, co je v políčku
                    customClass: "w-6",
                    disabled: true,
                })
                // spis_graf_v
                .addRow({
                    label: "jres:32131125" //RC 32131125 : Výpravní graf
                })
                .addField("gselectbox", Gordic.Prefabs.Select.wflsgra(), {
                    dropdown: false,                                                                 // políčko jako combobox
                    name: "spis_graf_v",                                                            // název položky
                    model: "model.spis_graf_v=value.spis_graf",                                       // model je to, co je na teto strance , value je to, co je v políčku
                    customClass: "spis_graf_v",                                 // pojmenovana class pro hledani v ramci funkce pro zneviditelneni policka
                    disabled: true,
                })

                .addSection("jres:32131139") //RC 32131139 : Výchozí nastavení pro vyřízení dokumentů
                // spis_pl, spis_znak
                .addRow({
                    label: "jres:32131121 " //RC 32131121 : Spisový plán
                })
                .addField("gselectbox", Gordic.Prefabs.Select.sslsspl(), {
                    dropdown: true,                                                                 // políčko jako combobox
                    name: "spis_pl",                                                            // název položky
                    model: "model.spis_pl=value.spis_pl",                                       // model je to, co je na teto strance , value je to, co je v políčku
                    disabled: true,
                })
                .addRow({
                    label: "jres:32131122" //RC 32131122 : Spisový znak
                })
                .addField("gselectbox", Gordic.Prefabs.Select.sslsspz(), {
                    dropdown: false,                                                                 // políčko jako combobox
                    name: "spis_znak",                                                            // název položky
                    model: "model.spis_pl=>value.spis_pl,model.spis_znak=value.spis_znak",                                       // model.ktg_typ=value.ktg_typ, 
                    disabled: !this.newRecord,
                    serverFilters: {
                        aktivita: null,
                        spis_pl: new Gordic.Forms.Dependency("spis_pl", "spis_pl", true, false, this.element)
                    },
                })

                .addSection("jres:32131140") //RC 32131140 : Výchozí nastavení pro vyřízení spisů
                // spis_pl_spis, spis_znak_spis
                .addRow({
                    label: "jres:32131121 " //RC 32131121 : Spisový plán
                })
                .addField("gselectbox", Gordic.Prefabs.Select.sslsspl(), {
                    dropdown: true,                                                                 // políčko jako combobox
                    name: "spis_pl_spis",                                                            // název položky
                    model: "model.spis_pl_spis=value.spis_pl",                                       // model je to, co je na teto strance , value je to, co je v políčku
                    disabled: true,
                })
                .addRow({
                    label: "jres:32131122" //RC 32131122 : Spisový znak
                })
                .addField("gselectbox", Gordic.Prefabs.Select.sslsspz(), {
                    dropdown: false,                                                                 // políčko jako combobox
                    name: "spis_znak_spis",                                                            // název položky
                    model: "model.spis_pl_spis=>value.spis_pl,model.spis_znak_spis=value.spis_znak",                                       // model.ktg_typ=value.ktg_typ, 
                    disabled: !this.newRecord,
                    serverFilters: {
                        aktivita: null,
                        spis_pl: new Gordic.Forms.Dependency("spis_pl_spis", "spis_pl", true, false, this.element)
                    },
                })

                .addSection("jres:32131141") //RC 32131141 : Výchozí nastavení pro kopie
                // spis_pl_kopie, spis_znak_kopie
                .addRow({
                    label: "jres:32131121 " //RC 32131121 : Spisový plán
                })
                .addField("gselectbox", Gordic.Prefabs.Select.sslsspl(), {
                    dropdown: true,                                                                 // políčko jako combobox
                    name: "spis_pl_kopie",                                                            // název položky
                    model: "model.spis_pl_kopie=value.spis_pl",                                       // model je to, co je na teto strance , value je to, co je v políčku
                    disabled: true,
                })
                .addRow({
                    label: "jres:32131122" //RC 32131122 : Spisový znak
                })
                .addField("gselectbox", Gordic.Prefabs.Select.sslsspz(), {
                    dropdown: false,                                                                 // políčko jako combobox
                    name: "spis_znak_kopie",                                                            // název položky
                    model: "model.spis_pl_kopie=>value.spis_pl,model.spis_znak_kopie=value.spis_znak",                                       // model.ktg_typ=value.ktg_typ, 
                    disabled: !this.newRecord,
                    serverFilters: {
                        aktivita: null,
                        spis_pl: new Gordic.Forms.Dependency("spis_pl_kopie", "spis_pl", true, false, this.element)
                    },
                })

                .addRow({
                    label: "jres:32131031" //RC 32131031 : Změnil
                })
                .addField("gselectbox", Gordic.Prefabs.Select.ginszmp(), {
                    disabled: true,
                    name: "ixs_zmp",                                                            // název položky
                    model: "model.zmenu_prov=value.ixs_zmp"                                       // model je to, co je na teto strance , value je to, co je v políčku
                })
                .addRow({
                    label: "jres:32131032" //RC 32131032 : Změněno
                })
                .addField("gdatebox", {
                    disabled: true,
                    name: "dat_zmena",
                    valueType: "datetime"
                })



            form.gform("createFrom", Form);

            this.loadData();            // ze serveru se načtou data a to i pro případ this.newRecord - v tom případě se čtou aspoň default value a permissions

            // Vytvoření funkce pro přechod na editační režim v rámci dvojkliku na libovolném políčku formuláře
            form.findFields().dblclick(() => {
                if (this.newRecord === false && Utils.getCanEdit(this.data.Permissions)) {
                    this.setEditMode(true);
                    this.setMenuButtons(true);
                }
            });


        }

        //#endregion

        //#region menubar

        /** vytvořit menubar */
        private createMenuBar() {

            const menuBar: MenuParams[] = [];

            // SAVE
            menuBar.push({
                favorite: true,
                action: this.actions.add(new GAction({
                    visible: this.newRecord,
                    name: "actSaveRecord",
                    icon: "gi-save",
                    caption: "jres:32131041",			//RC 32131041 : Uložit
                    run: () => {
                        // kolekce dat
                        var nova_data: Gordic.Adm.Interface.GWflsstpDto = {};       // vytvořím prázdný objekt správného typu
                        this.findFields().gfield("model", "collect", nova_data);    // načtu do něj data z formuláře
                        this.saveData(nova_data);                                   // pokusím se uložit data do DB
                    }
                }))
            });

            if (this.newRecord === false) {
                // EDIT
                menuBar.push({
                    favorite: true,
                    action: this.actions.add(new GAction({
                        visible: true,
                        name: "actEditRecord",
                        icon: "gi-pencil",
                        caption: "jres:32000120",			//RC 32000120 : Editace
                        run: () => {
                            this.setEditMode(true);
                            this.setMenuButtons(true);
                        }
                    }))
                });
                // CANCEL EDIT
                menuBar.push({
                    favorite: true,
                    action: this.actions.add(new GAction({
                        visible: false,
                        name: "actCancelSaveRecord",
                        icon: "gi-window-close",
                        caption: "jres:32000122",			//RC 32000122 : Ukončit editaci
                        run: () => {
                            this.refreshDetail();           // občerstvím původní data z databáze
                            this.HideAllFlash();
                            this.setEditMode(false);
                            this.setMenuButtons(false);
                        }
                    }))
                });
            }
            // REFRESH
            menuBar.push({
                align: "opposite",
                favorite: true,
                action: this.actions.add(new GAction({
                    icon: "gi-refresh",
                    name: "actRefresh",
                    caption: "jres:32131040",			//RC 32131040 : Občerstvení
                    run: () => {
                        this.refreshDetail();
                    }
                }))
            });

            this.menuBar(menuBar);

        }

        /** Přepnutí dostupnosti políček podle aktuálního režimu okna 
         editMode - příznak, že okno je v editačním režimu
         */
        private setEditMode(editMode: boolean) {
            // odblokování/zablokování všech políček formuláře 
            this.findFields().gfield("option", { disabled: !editMode });

            // vždy read only
            this.findFields("jeden").gfield("option", { disabled: true });
            this.findFields("dat_zmena").gfield("option", { disabled: true });
            this.findFields("ixs_zmp").gfield("option", { disabled: true });

            this.editMode = editMode;
        }

        /** Přepnutí viditelnost tlačítek podle aktuálního režimu okna 
         editMode - příznak, že okno je v editačním režimu
         */
        private setMenuButtons(editMode: boolean) {
            Utils.setActionVisible(this.actions.actEditRecord, !editMode);
            Utils.setActionEnabled(this.actions.actEditRecord, Utils.getCanEdit(this.data.Permissions));

            Utils.setActionVisible(this.actions.actSaveRecord, editMode);
            Utils.setActionVisible(this.actions.actCancelSaveRecord, editMode);
        }


        //#endregion

        //#region commandbar

        /** vytvořit commandbar */
        private createCommandBar() {

            const commandBar: MenuParams[] = [];

            // CLOSE
            commandBar.push({
                favorite: true,
                action: this.actions.add(new GAction({
                    name: "actZavrit",
                    icon: "gi-window-close",
                    caption: "jres:32131042",				//RC 32131042 : Zavřít
                    run: () => {
                        this.close();
                    }
                }))
            });

            this.commandBar(commandBar);

        }

        //#endregion

        //#region statusbar

        /** odstranit všechny vlastní třídy ze statusbaru */
        private removeAllCustomClassOnStatusBar() {
            var myclass = $(".statusbar-aktivita-class").find(".g-static__text");
            myclass.removeClass("statusbar-aktivita-class-green");
            myclass.removeClass("statusbar-aktivita-class-blue");
            myclass.removeClass("statusbar-aktivita-class-red");
        }

        //#endregion

        //#region sidebar

        /** vytvořit panel */
        private createPanel(): GSideBarPanelOptions {

            this.panelId = "panelNahled";

            let panel = {
                minWidth: 300,
                id: this.panelId,
                caption: "jres:32131038",							//RC 32131038 : Náhled
                leaf: "jres:32131038",								//RC 32131038 : Náhled
                icon: "gi-nahled",
                open: (ev, obj) => {
                    this.refreshPanel(ITypePanel.Neurceno, $(ev.target))
                },
            } as GSideBarPanelOptions;

            return panel;
        }

        /** odstranit sidebar */
        private removeSidebar() {
            if (this.sidebar !== undefined) {
                this.sidebar.gsidebar("removeAll");
            }
        }

        /** vytvořit sidebar */
        private createSidebar() {

            this.removeSidebar();
            var panel = this.createPanel();

            this.sidebar = $(this.element).gsidebar({
                userSettings: this.userSettings,
                right: {
                    pinned: true,
                    panels: [panel]
                }
            });
        }

        /** občerstvení panelu v sidebaru */
        private refreshPanel(type: ITypePanel, elementPanel?: JQuery<HTMLElement>): void {

            var panel: JQuery<HTMLElement> | undefined;

            if (this.sidebar !== undefined) {
                panel = this.sidebar.gsidebar("getPanel", this.panelId);
            }
            else {
                panel = elementPanel;
            }

            if (panel !== undefined) {

                if (this.panelElement !== undefined) {
                    this.panelElement.remove();
                }

                this.panelElement = $("<div>").appendTo(panel);

                //if (type === ITypePanel.HistorieSpusteni) {
                //	GridUtils.setPanelGrid("jres:32000055", this.row_historie_spusteni, this.gridFormatHistorieSpusteni, this.panelElement);
                //}
                //else {
                this.setPreviewEmpty();
                //}

            }

        }
        /** vytovření prázdného sidebar panelu s náhledek */
        private setPreviewEmpty(): void {
            var p7s_element = $("<div'>").addClass("Adm-p7s-class");
            p7s_element.appendTo(this.panelElement);
            p7s_element.text("jres:32131043"); //RC 32131043 : Náhled není k dispozici.
        }

        //#endregion

    }
}